import React, { memo, useEffect, useState, useRef } from 'react';
import { FormGroup } from 'react-bootstrap';
import { Input, Label } from 'reactstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import toastr from "toastr";
import { useDispatch, useSelector } from 'react-redux';
import { addArtworkForm } from 'store/actions';
import { Oval } from "react-loader-spinner";
const CertificateofAuthenticity = memo(({ dialogOpan, isPhysicalArt, setArtWorkId, previewart }) => {
    const [fieldsError, setfieldsError] = useState(false);
    const [isPrinterPanel, setIsPrinterPanel] = useState(true)
    const { loading } = useSelector((state) => state?.Print);
    const { user } = useSelector((state) => state?.Login);
    const dispatch = useDispatch()
    let additionalFields = ["artist_name", "art_work", "edition", "year_edition_released", "combined_edition_size", "edition_print", "authorized_max_number", "authorized_max_number_not_signed", "authorized_max_number_signed", "authorized_max_number_nothing", "edition_authorized_max_number", "edition_artist_proof", "edition_printer_proof", "edition_other_prrof", "year_master_created", "master_artist_living", "master_artwork_exist", "other_limited_edition", "master_edition", "edition_points", "other_master_proofs", "other_master_edition", "master_edition2", "other_master_edition_points", "master_proofs", "master_signed_number", "how_numbered", "other_prints", "print_produced", "non_master_authorized_prints", "destroyed", "main_artist", "other_artists",   "signed_number", "edition_artist_living"];
    // is_signed_1", "is_signature_from_original_2", "is_digital_signature_3", "has_two_signatures_4",
    let requiredFields = ["artist_name", "art_work", "edition", "year_edition_released", "year_master_created", "master_artist_living", "master_artwork_exist", "other_limited_edition", "master_edition", "edition_points", "other_master_proofs", "signed_number", "how_numbered", "other_prints", "print_produced", "non_master_authorized_prints", "destroyed", "main_artist", "other_artists", "edition_artist_living"]
    const [fields, setFields] = useState({
        artist_name: "",
        art_work: "",
        edition: "",
        token_id: "",
        print_made_year: "",
        printing_process: "",
        print_substrate: "",
        dimension: "",
        acid_free: "",
        restrike_replacement: "",
        magazine_print: false,
        artist_living: "",
        signed_by_artist: false,
        approved_by_artist: false,
        other_masters_exist: false,
        description: "",
        year_edition_released: '',
        authorized_max_number: "",
        other_limited_edition: "",
        print_dimensions: "",
        authorized_max_number_not_signed: "",
        edition_points: '',
        edition_print: '',
        proofs: '',
        signed_number: '',
        master_edition: '',
        other_master_edition: '',
        other_master_edition_points: '',
        master_proofs: '',
        master_signed_number: '',
        how_numbered: '',
        other_prints: '',
        print_produced: '',
        non_master_authorized_prints: '',
        destroyed: '',
        printer_name: "",
        year_master_created: "",
        master_artist_living: "",
        master_artwork_exist: "",
        main_artist: "",
        other_artists: "",
        edition_authorized_max_number: "",
        edition_artist_proof: "",
        edition_printer_proof: "",
        edition_other_prrof: "",
        artist_signed_print: "Yes",
        artist_approved_print: "Yes",
        new_edition_size: "1",
        combined_edition_size: "",
        authorized_max_number_signed: "",
        // authorized_max_number_signed_numbered: "",
        authorized_max_number_nothing: "",
        other_master_proofs: "",
        //new fields
        master_edition2: "",
        form_case: "create",
        "is_signed_1": false,
        "is_signature_from_original_2": false,
        "is_digital_signature_3": false,
        "has_two_signatures_4": false,
        is_physical_art: isPhysicalArt,
        edition_artist_living: "",
        limited_edition: "",
        edition_size: "",
        edition_proof: "None"
    })
    const closeAuthenticity = () => {
        dialogOpan()
    }

    const handleInputChange = (e) => {
        setErrors({});
        const { name, value } = e.target;
        if (
            ["is_signed_1", "is_signature_from_original_2", "is_digital_signature_3", "has_two_signatures_4"].includes(name)
        ) {
            setFields((p) => ({
                ...p,
                is_signed_1: name === "is_signed_1",
                is_signature_from_original_2: name === "is_signature_from_original_2",
                is_digital_signature_3: name === "is_digital_signature_3",
                has_two_signatures_4: name === "has_two_signatures_4",
            }));
        }
        else if (name === "limited_edition" || name === "edition_artist_living") {
            setFields((prevFields) => ({ ...prevFields, [name]: value }));
        }
        else if ((name === "artist_name" || name === "main_artist") && value.length <= 100) {
            setFields((prevFields) => ({ ...prevFields, [name]: value }));
        }
        else if (name === "art_work" && value.length <= 150) {
            setFields((prevFields) => ({ ...prevFields, art_work: value }));
        }
        else if (name === "other_artists" && value.length <= 500) {
            setFields((prevFields) => ({ ...prevFields, [name]: value }));
        }
        else if (name === "edition" && value.length <= 50) {
            setFields((prevFields) => ({ ...prevFields, edition: value }));
        } else if (name === "token_id" && /^[a-zA-Z0-9]*$/.test(value) && value.length <= 50) {
            setFields((prevFields) => ({ ...prevFields, token_id: value }));
        } else if (name === "print_made_year" && (/^\d{0,4}$/.test(value) || value === "")) {
            setFields((prevFields) => ({ ...prevFields, print_made_year: value }));
        } else if (name === "printing_process") {
            setFields((prevFields) => ({ ...prevFields, printing_process: value }));
        } else if (name === "print_substrate") {
            setFields((prevFields) => ({ ...prevFields, print_substrate: value }));
        } else if (name === "printer_name" && value.length <= 30) {
            setFields((prevFields) => ({ ...prevFields, printer_name: value }));
        }
        else if (name === "print_dimensions") {
            if (value.length <= 50) {
                setFields((prevFields) => ({ ...prevFields, print_dimensions: value }));
            }

        } else if (name === "acid_free") {
            setFields((prevFields) => ({ ...prevFields, acid_free: value }));
        }
        else if (name === "artist_living") {
            setFields((prevFields) => ({ ...prevFields, artist_living: value }));
        }
        else if (name === "restrike_replacement") {
            setFields((prevFields) => ({ ...prevFields, restrike_replacement: value }));
        }
        else if (name === "master_artwork_exist") {
            setFields((prevFields) => ({ ...prevFields, master_artwork_exist: value }));
        }
        else if (name === "description" && value.length <= 500) {

            setFields((prevFields) => ({ ...prevFields, description: value.trimStart() }))
        }
        else if ((name === "year_edition_released" || name === "year_master_created") && (/^\d{0,4}$/.test(value) || value === "")) {
            setFields((prevFields) => ({ ...prevFields, [name]: value }));
        }
        else if (name === "master_artist_living") {
            setFields((prevFields) => ({ ...prevFields, master_artist_living: value }));
        }

        else if (name === "master_artwork_exist" && (/^\d{0,4}$/.test(value) || value === "")) {
            setFields((prevFields) => ({ ...prevFields, master_artwork_exist: value }));
        }

        // else if (name === "other_limited_edition" && /^[0-9]*$/.test(value) && value.length <= 8) {
        //     setFields((prevFields) => ({ ...prevFields, other_limited_edition: value }));
        // }
        else if (name === "authorized_max_number" || name === "authorized_max_number_not_signed" || name === "authorized_max_number_signed" || name === "edition_size") {

            // Allow only numbers and restrict max length
            if (/^\d*$/.test(value) && value.length <= 8) {
                setFields((prevFields) => ({ ...prevFields, [name]: value }));
            }
        }
        else if (name === "other_limited_edition" || name === "proofs" || name === "signed_number" || name === "master_edition" || name === "other_master_edition" || name === "master_edition2" || name === "other_master_edition_points" || name === "master_proofs" || name === "master_signed_number" || name === "how_numbered" || name === "other_prints" || name === "print_produced" || name === "non_master_authorized_prints" || name === "edition_print" || name === "edition_authorized_max_number" || name === "edition_artist_proof" || name === "edition_printer_proof" || name === "edition_other_prrof" || name === "combined_edition_size" || name === "authorized_max_number_nothing" || name === "other_master_proofs" || name === "edition_points"
        ) {

            // Allow only numeric input and restrict to 8 digits
            if (/^\d*$/.test(value) && value.length <= 8) {
                setFields((prevFields) => ({
                    ...prevFields,
                    [name]: value,
                }));
            }
        }
        else if (name === "destroyed") {
            setFields((prevFields) => ({ ...prevFields, destroyed: value }));
        }
    }


    const artistInputRef = useRef(null);
    const artWorkInputRef = useRef(null);
    const editionInputRef = useRef(null);
    const editionPrintInputRef = useRef(null);
    const authorizedMaxSignedRef = useRef(null);
    const authorizedMaxNotSignedRef = useRef(null);
    const authorizedMaxNothingRef = useRef(null);
    const editionAuthorizedMaxRef = useRef(null);
    const editionArtistProofRef = useRef(null);
    const editionPrinterProofRef = useRef(null);
    const editionOtherProofRef = useRef(null);
    const otherLimitedEditionRef = useRef(null);
    const howNumberedRef = useRef(null);
    const otherPrintsRef = useRef(null);
    const editionPointsRef = useRef(null);
    const masterProofsRef = useRef(null);
    const signedNumberRef = useRef(null);
    const otherMasterEditionRef = useRef(null);
    const masterEditionRef = useRef(null);
    const otherMasterEditionPointsRef = useRef(null);
    const otherMasterProofsRef = useRef(null);
    const masterSignedNumberRef = useRef(null);
    const printProducedRef = useRef(null);
    const nonMasterAuthorizedPrintsRef = useRef(null);
    const mainArtistRef = useRef(null);
    const otherArtistsRef = useRef(null);
    const yearEditionReleasedRef = useRef(null);
    const yearMasterCreatedRef = useRef(null);
    const editionSizeRef = useRef(null);
    const combinedEditionSizeRef = useRef(null);
    const authorizedMaxNumberRef = useRef(null);
    const otherMasterLimitedEditionRef = useRef(null)
    const masterEdition2Ref = useRef(null)
    const editionArtistLivingRef = useRef(null);
    const masterArtistLivingRef = useRef(null);
    const masterArtworkExistRef = useRef(null)
    const destroyedRef = useRef(null);
    const limitedEditionRef = useRef(null);

    const handleBlur = (name) => {
        const newErrors = { ...errors };
        let firstInvalidRef = null; // Store only the first invalid input

        const validateField = (fieldName, errorMessage, ref) => {
            if (!fields?.[fieldName]?.trim()) {
                newErrors[fieldName] = errorMessage;
                if (!firstInvalidRef && ref?.current) firstInvalidRef = ref; // Store first invalid ref
            } else {
                delete newErrors[fieldName];
            }
        };

        const validateNumber = (fieldName, errorMessage, ref, min = 1, max = Infinity) => {
            const value = parseInt(fields[fieldName]?.trim() || "0", 10);
            if (!fields[fieldName]?.trim() || isNaN(value) || value < min || value > max) {
                newErrors[fieldName] = errorMessage;
                if (!firstInvalidRef && ref?.current) firstInvalidRef = ref;
            } else {
                delete newErrors[fieldName];
            }
        };

        // Validation rules
        const validationRules = {
            artist_name: [validateField, "This field is required.", artistInputRef],
            art_work: [validateField, "is required.", artWorkInputRef],
            edition: [validateField, "This field is required.", editionInputRef],
            edition_print: [validateField, "This field is required.", editionPrintInputRef],
            authorized_max_number_signed: [validateNumber, "Enter a valid number.", authorizedMaxSignedRef, 1],
            authorized_max_number_not_signed: [validateNumber, "Enter a valid number.", authorizedMaxNotSignedRef, 1],
            authorized_max_number_nothing: [validateNumber, "Enter a valid number.", authorizedMaxNothingRef, 1],
            edition_authorized_max_number: [validateNumber, "Enter a valid number.", editionAuthorizedMaxRef, 1],
            // edition_size: [validateNumber, "Enter a valid number.", editionSizeRef, 1],
            combined_edition_size: [validateNumber, "Enter a valid number.", combinedEditionSizeRef, 1],
            year_edition_released: [validateNumber, "Enter a valid year (1900 - 2100).", yearEditionReleasedRef, 1900, 2100],
            authorized_max_number: [validateNumber, "Enter a valid number.", authorizedMaxNumberRef, 1],
            edition_artist_proof: [validateNumber, "Enter a valid number.", editionArtistProofRef, 0],
            edition_printer_proof: [validateNumber, "Enter a valid number.", editionPrinterProofRef, 0],
            edition_other_proof: [validateNumber, "Enter a valid number.", editionOtherProofRef, 0],
            year_master_created: [validateNumber, "Enter a valid year (1900 - 2100).", yearMasterCreatedRef, 1900, 2100],
            other_limited_edition: [validateField, "This field is required.", otherMasterLimitedEditionRef],
            master_edition: [validateField, "This field is required.", masterEditionRef],
            edition_points: [validateNumber, "Enter a valid number.", editionPointsRef, 1],
            other_master_proofs: [validateField, "This field is required.", otherMasterProofsRef],
            other_master_edition: [validateField, "This field is required.", otherMasterEditionRef],
            master_edition2: [validateField, "This field is required.", masterEdition2Ref],
            signed_number: [validateNumber, "Enter a valid number.", signedNumberRef, 1],
            how_numbered: [validateField, "This field is required.", howNumberedRef],
            other_prints: [validateField, "This field is required.", otherPrintsRef],
            print_produced: [validateField, "This field is required.", printProducedRef],
            main_artist: [validateField, "This field is required.", mainArtistRef],
            other_artists: [validateField, "This field is required.", otherArtistsRef],
            other_master_edition_points: [validateNumber, "Enter a valid number.", otherMasterEditionPointsRef, 1],
            master_proofs: [validateField, "This field is required.", masterProofsRef],
            master_signed_number: [validateNumber, "Enter a valid number.", masterSignedNumberRef, 1],
            non_master_authorized_prints: [validateNumber, "Enter a valid number.", nonMasterAuthorizedPrintsRef, 1],
            edition_artist_living: [validateField, "This field is required.", editionArtistLivingRef, 1],
            master_artist_living: [validateField, "This field is required.", masterArtistLivingRef, 1],
            master_artwork_exist: [validateField, "This field is required.", masterArtworkExistRef, 1],
            destroyed: [validateField, "This field is required.", destroyedRef, 1],
            limited_edition: [validateField, "This field is required.", limitedEditionRef, 1],
        };

        // Validate the given field
        if (validationRules[name]) {
            const [validator, errorMessage, ref, min, max] = validationRules[name];
            validator(name, errorMessage, ref, min, max);
        }

        // Update errors state
        setErrors(newErrors);

        // Ensure firstInvalidRef exists before focusing
        if (firstInvalidRef?.current) {
            // setTimeout(() => {
            firstInvalidRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
            firstInvalidRef.current?.focus();
            // }, 100); // Shorter delay for faster response
        }

        return !!firstInvalidRef; // Returns true if an error exists
    };


    const [errors, setErrors] = useState({});
    const handleSubmit = () => {
        const fieldList2 = isPhysicalArt ? additionalFields : requiredFields;
        const fieldList = isPhysicalArt ? additionalFields : requiredFields;
        if (
            fields?.is_signed_1 === false &&
            fields?.is_signature_from_original_2 === false &&
            fields?.is_digital_signature_3 === false &&
            fields?.has_two_signatures_4 === false
        ) {
            toastr.error("Please select at least one checkbox.");
            return;
        }

        let newErrors = { ...errors };
        let firstInvalidFieldRef = null;
       

        const fieldRefs = {
            artist_name: artistInputRef,
            art_work: artWorkInputRef,
            edition: editionInputRef,
            edition_print: editionPrintInputRef,
            authorized_max_number_signed: authorizedMaxSignedRef,
            authorized_max_number_not_signed: authorizedMaxNotSignedRef,
            authorized_max_number_nothing: authorizedMaxNothingRef,
            edition_authorized_max_number: editionAuthorizedMaxRef,
            year_edition_released: yearEditionReleasedRef,
            authorized_max_number: authorizedMaxNumberRef,
        };
        fieldList.forEach((fieldName) => {
            
            if (!fields[fieldName] || (typeof fields[fieldName] === "string" && !fields[fieldName].trim())) {
                newErrors[fieldName] = `This field is required.`;

                if (!firstInvalidFieldRef) {
                    firstInvalidFieldRef = fieldRefs[fieldName];
                }
                return 
            } else {
                delete newErrors[fieldName];
            }
        });
         
        setErrors(newErrors);



        if (firstInvalidFieldRef?.current) {
            firstInvalidFieldRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
            firstInvalidFieldRef.current.focus()
            return;
        }
    

        const callback = (response) => {
            if (response.status === "success") {
                setArtWorkId(response?.data?._id);
                toastr.success("Form submitted successfully");
                dialogOpan();
            }
        };    
        // const excludedFields = [
        //     "acid_free", "dimension", "artist_living", "print_dimensions", 
        //     "print_made_year", "print_substrate", "printer_name", "printing_process", 
        //     "proofs", "restrike_replacement", "token_id"
        // ];
        // console.log("djfklasdjfk", errors)
        // const errorFields = fieldList2.filter(field => 
        //     !excludedFields.includes(field) && (newErrors[field] !== "")
        // );
        const errorFields = [];
        for (let key in newErrors) {
            if (newErrors[key] !== "") {
                errorFields.push(newErrors[key]);
            }
        }
        console.log("fdasjklfjasdklf", newErrors)
        if (errorFields.length > 0) {
            console.log("Fields with errors:", errorFields);
            return toastr.error(`Please fill required fields.`);
        }
        
        const obj = { ...fields, form_case: "create" };

        dispatch(addArtworkForm(obj, callback));
    };
    useEffect(() => {
        let obj = {}
        Object.entries(fields).forEach(([field, message]) => {
            obj[field] = ""
        });
        setErrors(obj)
    }, [fields])

    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            For Print Shop
        </Tooltip>
    );
    useEffect(() => {
        setFields((p) => ({ ...p, is_physical_art: isPhysicalArt }))
    }, [isPhysicalArt])
    return <>
        {(loading) &&
            <div className='loaderBoxMiane'>
                <Oval
                    height={80}
                    width={80}
                    color="#6C63FF"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={true}
                    ariaLabel='oval-loading'
                    secondaryColor="#6C63FF"
                    strokeWidth={2}
                    strokeWidthSecondary={2}
                />
            </div>
        }
        <div
            className="modal fade show"
            id="exampleModalCenter"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalCenterTitle"
            aria-hidden="true"
            style={{ display: 'block' }}
        >
            <div className="modal-dialog modal-dialog-centered" id="modal-dialog" role="document">
                <div className="modal-content text-start" id="modal-content">
                    <div className="modal-header">
                        <svg className="svg-icon-img" onClick={closeAuthenticity} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z" /></svg>
                    </div>
                    <div className="modal-body contentOverflow">
                        <p className="arts">Certificate of Authenticity</p>
                        <p className="art">{previewart}</p>
                        <p className="artist">By {user?.name?.charAt(0).toUpperCase() + user?.name?.slice(1) + " " +
                            user?.lastname?.charAt(0).toUpperCase() + user?.lastname?.slice(1)}
                        </p>
                        <p className="open-text">  {isPhysicalArt === true ? 'LIMITED EDITION PRINT' : 'OPEN EDITION PRINT'}</p>
                        {isPhysicalArt === true ? <>
                            <p className="art-text">This  [Title]Limited Edition print is one of a limited number of prints that are together referred to in this Certificate of Authenticity as the “Edition.” It is a giclée rendition of a high-resolution digital photographic image of the Artist’s original [oil painting][acrylic painting][watercolor][pencil drawing][ink drawing][mixed media artwork] [etc.],modified to incorporate unique corrections and refinements satisfying the requirements of the Artist. When completed, the image was preserved in only onedigital file,referred to in this Certificate as the “Master.”Duplicates of the Master, identical to it in all respects, have since been made in order to facilitate the creation of the prints in the Edition. Distribution of duplicates is limited to authorized printers contractually bound to use them for no purpose other than the creation of prints in this Edition and to destroy them after such use.References below to the Master include its identical duplicates.</p>
                            <p className="art-text">All prints in the Edition are produced from the Master.Prints in the Edition may differ in dimensions or substrate.The Artist has approved the Master and the processes, techniques, materials and proofs used in the production of the Editionin writing.Prints in the Edition are not individually approved by the Artist. The total number of prints that will be produced in the Edition from the Master is shown below.</p>
                            <div className="CustomeCheckBox mb-3">
                                <Input onChange={handleInputChange} id="openedition1" name='is_signed_1' checked={fields?.is_signed_1} value={fields?.is_signed_1} type="checkbox" />
                                <label htmlFor="openedition1"></label>
                                <div><span className=" text-black certificate-text">Neither the original artwork nor any prints in the Edition are signed by the Artist.</span></div>
                            </div>
                            <div className="CustomeCheckBox mb-3">
                                <Input id="openedition2" type="checkbox" name='is_signature_from_original_2' value={fields?.is_signature_from_original_2} onChange={handleInputChange} checked={fields?.is_signature_from_original_2} />
                                <label htmlFor="openedition2"></label>
                                <div><span className=" text-black certificate-text">Prints in the Edition are not individually signed by the Artist. The Artist’s signature seen on the print is the signature that appears on the original artwork and is a part of the print itself.</span></div>
                            </div>
                            <div className="CustomeCheckBox mb-3">
                                <Input id="openedition3" type="checkbox" checked={fields?.is_digital_signature_3} value={fields?.is_digital_signature_3} name='is_digital_signature_3' onChange={handleInputChange} />
                                <label htmlFor="openedition3"></label>
                                <div><span className=" text-black certificate-text">Prints in the Edition are not individually signed by the Artist. The Artist’s signature on the print is a digital reproduction of the Artist’s signature that was specially incorporated into the Master at the direction of the Artist and is a part of the print itself.</span></div>
                            </div>
                            <div className="CustomeCheckBox mb-3">
                                <Input id="openedition4" type="checkbox" checked={fields?.has_two_signatures_4} value={fields?.has_two_signatures_4} name='has_two_signatures_4' onChange={handleInputChange} />
                                <label htmlFor="openedition4"></label>
                                <div><span className=" text-black certificate-text">Prints in the Edition are not individually signed by the Artist. The Artist’s signature appears twice on the print, in both cases as a part of the print itself. One signature is the signature of the Artist that appears on the original artwork and the other is a digital reproduction of the Artist’s signature that was specially incorporated into the Master at the direction of the Artist.</span></div>
                            </div>
                            <p className="art-text">This print was created in conjunction with the original sale of aNon-Fungible Token identified by the Token ID shown below (the “Digital Artwork”).The Digital Artwork was minted on the Polygon blockchainby the Artist as part of a limited seriesof Digital Artworks (“Origin Digital Artworks”). The blockchain shows the number of Origin Digital Artworks that are minted as they are minted, and thus the number of prints in the Edition that are created over time.Instead of traditional limited-edition numbering (i.e., 1/40, 2/40, etc.), prints in the Edition have the unique Token ID of theirassociated Non-Fungible Token imprinted in their margin. The Digital Artwork conveys to its owner online-only access to a digital image derived from the Master, and, to the original owner only, it conveyed ownership of a single print in the Edition. This is the print first owned by the original purchaser of the Digital Artwork. It exists wholly apart from and independent of the Digital Artwork. The sale or other transfer of any interest in the Digital Artwork does not transfer any interest in, or have any other effect upon, ownership of thisprint, and vice versa. This print is sold or otherwise transferred off the blockchain.</p>
                            <p className="art-text">The following information supplements the information provided above. All information in this Certificate is current as of the date of the signature below.</p>
                        </> : <>
                            <p className="art-text">This  [Art work Title] Open Edition print is one of a number of prints that are together referred to in this Certificate of Authenticity as the “Edition.” It is a giclée rendition of a high-resolution digital photographic image of the Artist’s original [oil painting][acrylic painting][watercolor][pencil drawing][ink drawing][mixed media artwork] [etc.] modified to incorporate unique corrections and refinements satisfying the requirements of the Artist. When completed, the image was preserved in only one digital file, referred to in this Certificate as the “Master.” Duplicates of the Master, identical to it in all respects, have since been made in order to facilitate the creation of the prints in the Edition. Distribution of duplicates is limited to authorized printers contractually bound to use them for no purpose other than the creation of prints in this Edition and to destroy them after such use.References below to the Master include its identical duplicates.</p>
                            <p className="art-text">All prints in the Edition are produced from the Master.Prints in the Edition may differ in dimensions or substrate. The Artist has approved the Master and the processes, techniques, materials and proofs used in the production of the Edition in writing. The Artist has not specifically approved this individual print. The total number of prints that will be produced in the Edition is unknown.</p>

                            <div className="CustomeCheckBox mb-3">
                                <Input id="openedition1" type="checkbox" name='is_signed_1' checked={fields?.is_signed_1} value={fields?.is_signed_1}
                                    onChange={handleInputChange} />
                                <label htmlFor="openedition1"></label>
                                <div><span className=" text-black certificate-text">Neither the original artwork nor any prints in the Edition are signed by the Artist.</span></div>
                            </div>
                            <div className="CustomeCheckBox mb-3">
                                <Input id="openedition2" type="checkbox" name='is_signature_from_original_2' value={fields?.is_signature_from_original_2} onChange={handleInputChange} checked={fields?.is_signature_from_original_2} />
                                <label htmlFor="openedition2"></label>
                                <div><span className=" text-black certificate-text">Prints in the Edition are not individually signed by the Artist. The Artist’s signature seen on the print is the signature that appears on the original artwork and is a part of the print itself.</span></div>
                            </div>
                            <div className="CustomeCheckBox mb-3">
                                <Input id="openedition3" type="checkbox" checked={fields?.is_digital_signature_3} value={fields?.is_digital_signature_3} name='is_digital_signature_3' onChange={handleInputChange} />
                                <label htmlFor="openedition3"></label>
                                <div><span className=" text-black certificate-text">Prints in the Edition are not individually signed by the Artist. The Artist’s signature on the print is a digital reproduction of the Artist’s signature that was specially incorporated into the Master at the direction of the Artist and is a part of the print itself.</span></div>
                            </div>
                            <div className="CustomeCheckBox mb-3">
                                <Input id="openedition4" checked={fields?.has_two_signatures_4} type="checkbox" value={fields?.has_two_signatures_4} name='has_two_signatures_4' onChange={handleInputChange} />
                                <label htmlFor="openedition4"></label>
                                <div><span className=" text-black certificate-text">Prints in the Edition are not individually signed by the Artist. The Artist’s signature appears twice on the print, in both cases as a part of the print itself. One signature is the signature of the Artist that appears on the original artwork and the other is a digital reproduction of the Artist’s signature that was specially incorporated into the Master at the direction of the Artist.</span>
                                </div>
                            </div>

                            {/* [] [][] [] */}
                            <p className="art-text">The following information supplements the information provided above. All information in this Certificate is current as of the date of the signature below.</p>
                        </>}


                        <form id="form" className='createCollection' style={{ position: 'relative' }}>
                            <div className='row justify-content-between'>
                                <div className='col-md-5'>
                                    <div className='row'>
                                        <div className='col-md-12 mb-3'>
                                            <FormGroup className="form-group">
                                                <Label className="mb-1 lableSmall">Artist</Label>
                                                <Input
                                                    name="artist_name"
                                                    type="text"
                                                    value={fields?.artist_name}
                                                    innerRef={artistInputRef}  // ✅ Use innerRef instead of ref for reactstrap Input
                                                    onChange={handleInputChange}
                                                    onBlur={() => handleBlur("artist_name")}
                                                    placeholder="Artist's Name"
                                                    className={`form-control bg-white ${errors.artist_name ? "border-danger" : ""}`}  // Highlight if error
                                                />
                                                {errors.artist_name && <p className="text-danger mt-1">{errors.artist_name}</p>}
                                            </FormGroup>
                                        </div>
                                        <div className='col-md-12 mb-3'>
                                            <FormGroup className="form-group">
                                                <Label className="mb-1 lableSmall">Art Work</Label>
                                                <Input
                                                    name="art_work"
                                                    type="text"
                                                    value={fields.art_work}
                                                    innerRef={artWorkInputRef}  // ✅ Dynamic ref assignment
                                                    onChange={handleInputChange}
                                                    onBlur={() => handleBlur("art_work")}
                                                    placeholder="Title of the artwork reproduced"
                                                    className={`form-control bg-white ${errors.art_work ? "border-danger" : ""}`}
                                                />
                                                {errors.art_work && <p className="text-danger mt-1">{errors.art_work}</p>}

                                            </FormGroup>
                                        </div>
                                        <div className='col-md-12 mb-3'>
                                            <FormGroup className="form-group">
                                                <Label className="mb-1 lableSmall">Edition</Label>
                                                <Input
                                                    id="form-control"
                                                    name="edition"
                                                    value={fields.edition}
                                                    onChange={handleInputChange}
                                                    onBlur={() => handleBlur("edition")}
                                                    placeholder="Title of the edition"
                                                    className={`form-control bg-white ${errors.edition ? "border-danger" : ""}`}
                                                    innerRef={editionInputRef} // ✅ Attach ref
                                                />
                                                {errors.edition && <p className="text-danger mt-1">{errors.edition}</p>}
                                            </FormGroup>
                                        </div>

                                        <div className='col-md-12'>
                                            <p className="edit-info mb-1">This Print</p>
                                        </div>
                                        <div className='col-md-12'>
                                            <div className='row'>
                                                {isPhysicalArt === true &&
                                                    <div className='col-lg-6 mb-3'>
                                                        <FormGroup className="form-group mb-0">
                                                            <Label className="mb-1 lableSmall">Token ID No.
                                                                <OverlayTrigger
                                                                    placement="top"
                                                                    delay={{ show: 250, hide: 400 }}
                                                                    overlay={renderTooltip}

                                                                ><i class="fa-solid fa-circle-info"></i></OverlayTrigger></Label>
                                                            <Input id="form-control"
                                                                name="token_id"
                                                                disabled={isPrinterPanel}
                                                                value={fields.token_id}
                                                                onChange={handleInputChange}
                                                                onBlur={() => handleBlur("token_id")}
                                                                // onChange={onChangeHandler("name")}
                                                                placeholder="Enter Token ID No"
                                                                className="form-control bg-white"
                                                                required={fieldsError?.nameError}
                                                            // placeholder="Item Name"
                                                            />
                                                        </FormGroup>
                                                    </div>
                                                }
                                                <div className='col-lg-6 mb-3'>
                                                    <FormGroup className="form-group mb-0">
                                                        <Label className="mb-1 lableSmall">Year Print Made <OverlayTrigger
                                                            placement="top"
                                                            delay={{ show: 250, hide: 400 }}
                                                            overlay={renderTooltip}
                                                        ><i class="fa-solid fa-circle-info"></i></OverlayTrigger></Label>
                                                        <Input id="form-control"
                                                            name="print_made_year"
                                                            disabled={isPrinterPanel}
                                                            placeholder="Enter Print Made year"
                                                            value={fields.print_made_year}
                                                            onChange={handleInputChange}
                                                            onBlur={() => handleBlur("print_made_year")}
                                                            // disabled={isPrintShop}
                                                            className="form-control bg-white"
                                                            required={fieldsError?.nameError}
                                                        />
                                                    </FormGroup>
                                                </div>
                                                <div className='col-lg-6 mb-3'>
                                                    <FormGroup className="form-group mb-0">
                                                        <Label className="mb-1 lableSmall">Printing Process <OverlayTrigger
                                                            placement="top"

                                                            delay={{ show: 250, hide: 400 }}
                                                            overlay={renderTooltip}
                                                        ><i class="fa-solid fa-circle-info"></i></OverlayTrigger></Label>
                                                        <Input id="form-control"
                                                            name="printing_process"
                                                            type="select"
                                                            // disabled={isPrintShop}
                                                            disabled={isPrinterPanel}
                                                            value={fields.printing_process}
                                                            onChange={handleInputChange}
                                                            onBlur={() => handleBlur("printing_process")}
                                                            placeholder=""
                                                            className="form-control bg-white"
                                                            required={fieldsError?.nameError}
                                                        >
                                                            <option value="" disabled>Select a valid printing process.</option>
                                                            <option value="Giclée">Giclée</option>
                                                            <option value="Offset">Offset</option>
                                                            <option value="Lithograph">Lithograph</option>

                                                        </Input>
                                                    </FormGroup>
                                                </div>
                                                <div className='col-lg-6 mb-3'>
                                                    <FormGroup className="form-group mb-0">
                                                        <Label className="mb-1 lableSmall">Print Dimensions <OverlayTrigger
                                                            placement="top"
                                                            delay={{ show: 250, hide: 400 }}
                                                            overlay={renderTooltip}
                                                        ><i class="fa-solid fa-circle-info"></i></OverlayTrigger></Label>
                                                        <Input id="form-control"
                                                            name="print_dimensions"
                                                            disabled={isPrinterPanel}
                                                            // onChange={onChangeHandler("name")}
                                                            value={fields.print_dimensions}
                                                            onChange={handleInputChange}
                                                            onBlur={() => handleBlur("print_dimensions")}
                                                            placeholder="Enter Print Dimensions"
                                                            className="form-control bg-white"
                                                            required={fieldsError?.nameError}
                                                        // placeholder="Item Name"
                                                        />
                                                    </FormGroup>
                                                </div>
                                                <div className='col-lg-6 mb-3'>
                                                    <FormGroup className="form-group mb-0">
                                                        <Label className="mb-1 lableSmall">Print Substrate <OverlayTrigger
                                                            placement="top"
                                                            delay={{ show: 250, hide: 400 }}
                                                            overlay={renderTooltip}
                                                        ><i class="fa-solid fa-circle-info"></i></OverlayTrigger></Label>
                                                        <Input id="form-control"
                                                            name="print_substrate"
                                                            type="select"
                                                            disabled={isPrinterPanel}
                                                            value={fields.print_substrate}
                                                            onChange={handleInputChange}
                                                            onBlur={() => handleBlur("print_substrate")}
                                                            placeholder=""
                                                            className="form-control bg-white"
                                                            required={fieldsError?.nameError}
                                                        >
                                                            <option value="" disabled>Select Print Substrate</option>
                                                            <option value="Canvas">Canvas</option>
                                                            <option value="Paper">Paper</option>
                                                            <option value="Others">Others</option>
                                                        </Input>
                                                    </FormGroup>
                                                </div>

                                            </div>
                                        </div>
                                        <div class="col-md-12 mb-3">
                                            <div className='form-group'>
                                                <Label>Acid-Free <OverlayTrigger
                                                    placement="top"
                                                    delay={{ show: 250, hide: 400 }}
                                                    overlay={renderTooltip}
                                                ><i class="fa-solid fa-circle-info"></i></OverlayTrigger></Label>

                                                <div className="d-flex gap-4 align-items-center">
                                                    <div className="form-check d-flex align-items-center">
                                                        <Input
                                                            className="form-check-input"
                                                            type="radio"
                                                            disabled={isPrinterPanel}
                                                            name="acid_free"
                                                            value="Yes"
                                                            checked={fields.acid_free === "Yes"}
                                                            onChange={handleInputChange}
                                                            onBlur={() => handleBlur("acid_free")}
                                                        />
                                                        <Label className="form-check-label mt-1" htmlFor="restrikeYes">Yes</Label>
                                                    </div>
                                                    <div className="form-check d-flex align-items-center">
                                                        <Input
                                                            className="form-check-input"
                                                            type="radio"
                                                            disabled={isPrinterPanel}
                                                            name="acid_free"
                                                            value="No"
                                                            checked={fields.acid_free === "No"}
                                                            onChange={handleInputChange}
                                                            onBlur={() => handleBlur("acid_free")}
                                                        />
                                                        <Label className="form-check-label mt-1" htmlFor="restrikeNo">No</Label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {isPhysicalArt === true &&
                                            <div className="col-md-12 mb-3">
                                                <FormGroup className="form-group">
                                                    <Label className="mb-1 lableSmall">Restrike/Replacement
                                                        <i className="fa-solid fa-circle-info" data-toggle="tooltip" title="Select whether this is a restrike or replacement."></i>
                                                    </Label>
                                                    <div className="d-flex gap-4 align-items-center">
                                                        <div className="form-check d-flex align-items-center">
                                                            <Input
                                                                disabled={isPrinterPanel}
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="restrike_replacement"
                                                                value="Yes"
                                                                checked={fields.restrike_replacement === "Yes"}
                                                                onChange={handleInputChange}
                                                                onBlur={() => handleBlur("restrike_replacement")}
                                                            />
                                                            <Label className="form-check-label mt-1" htmlFor="restrikeYes">Yes</Label>
                                                        </div>
                                                        <div className="form-check d-flex align-items-center">
                                                            <Input
                                                                className="form-check-input"
                                                                disabled={isPrinterPanel}
                                                                type="radio"
                                                                name="restrike_replacement"
                                                                value="No"
                                                                checked={fields.restrike_replacement === "No"}
                                                                onChange={handleInputChange}
                                                                onBlur={() => handleBlur("restrike_replacement")}
                                                            />
                                                            <Label className="form-check-label mt-1" htmlFor="restrikeNo">No</Label>
                                                        </div>
                                                    </div>
                                                </FormGroup>
                                            </div>
                                        }

                                        <div class="col-md-12 mb-3">
                                            <label>Book/magazine print</label>
                                            <p className="edit-info mb-0">
                                                No
                                            </p>
                                        </div>
                                        <div class="col-md-12 mb-3">
                                            <div className='form-group'>
                                                <label>Artist living when Print made <OverlayTrigger
                                                    placement="top"
                                                    delay={{ show: 250, hide: 400 }}
                                                    overlay={renderTooltip}
                                                ><i class="fa-solid fa-circle-info"></i></OverlayTrigger></label>
                                                <div className="d-flex gap-4 align-items-center">
                                                    <div className="form-check d-flex align-items-center">
                                                        <Input
                                                            disabled={isPrinterPanel}
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="artist_living"
                                                            value="Yes"
                                                            checked={fields.artist_living === "Yes"}
                                                            onChange={handleInputChange}
                                                            onBlur={() => handleBlur("artist_living")}
                                                        />
                                                        <Label className="form-check-label mt-1" htmlFor="restrikeYes">Yes</Label>
                                                    </div>
                                                    <div className="form-check d-flex align-items-center">
                                                        <Input
                                                            disabled={isPrinterPanel}
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="artist_living"
                                                            value="No"
                                                            checked={fields.artist_living === "No"}
                                                            onChange={handleInputChange}
                                                            onBlur={() => handleBlur("artist_living")}
                                                        />
                                                        <Label className="form-check-label mt-1" htmlFor="restrikeNo">No</Label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12 mb-3">
                                            <label>Print individually signed by the Artist?</label>
                                            <p className="edit-info mb-0">No</p>
                                        </div>
                                        <div class="col-md-12 mb-3">
                                            <label>Print individually approved by the Artist?</label>
                                            <p className="edit-info mb-0">No</p>
                                        </div>
                                        <div class="col-md-12 mb-3">

                                            <FormGroup className="form-group mb-0">
                                                <Label className="mb-1 lableSmall">Printed By <OverlayTrigger
                                                    placement="top"
                                                    delay={{ show: 250, hide: 400 }}
                                                    overlay={renderTooltip}
                                                ><i class="fa-solid fa-circle-info"></i></OverlayTrigger></Label>
                                                <Input id="form-control"
                                                    disabled={isPrinterPanel}
                                                    name="printer_name"
                                                    value={fields.printer_name}
                                                    onChange={handleInputChange}
                                                    onBlur={() => handleBlur("printer_name")}

                                                    // onChange={onChangeHandler("name")}
                                                    placeholder="Name of Printer"
                                                    className="form-control bg-white"
                                                // required={fieldsError?.nameError}
                                                // placeholder="Item Name"
                                                />
                                            </FormGroup>
                                        </div>
                                        <div class="col-md-12">
                                            <p className="edit-info mb-1">Edition Information</p>
                                        </div>
                                        <div class="col-md-12 mb-3">
                                            <FormGroup className="form-group mb-0">
                                                <Label className="mb-1 lableSmall">Year Edition Released</Label>
                                                <Input
                                                    id="form-control"
                                                    name="year_edition_released"
                                                    value={fields?.year_edition_released}
                                                    placeholder="Enter Year Edition Released"
                                                    className={`form-control bg-white ${errors.year_edition_released ? "border-danger" : ""}`}
                                                    onChange={handleInputChange}
                                                    onBlur={() => handleBlur("year_edition_released")}
                                                    innerRef={yearEditionReleasedRef} // ✅ Attach ref
                                                />
                                                {errors.year_edition_released && <p className="text-danger mt-1">{errors.year_edition_released}</p>}
                                            </FormGroup>

                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <label>Limited Edition</label>

                                            <div className="d-flex gap-4 align-items-center">
                                                <div>
                                                    <div className="form-check d-flex align-items-center">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="limited_edition"
                                                            id="flexRadioYes"
                                                            value="Yes"
                                                            checked={fields.limited_edition === "Yes"} // ✅ Control checked state
                                                            onChange={handleInputChange}
                                                            onBlur={() => handleBlur("limited_edition")}
                                                            ref={editionArtistLivingRef}
                                                        />
                                                        <label className="form-check-label mt-1" htmlFor="flexRadioYes">
                                                            Yes
                                                        </label>
                                                    </div>
                                                </div>

                                                <div>
                                                    <div className="form-check d-flex align-items-center">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="limited_edition"
                                                            id="flexRadioNo"
                                                            value="No"
                                                            checked={fields.limited_edition === "No"} // ✅ Control checked state
                                                            onChange={handleInputChange}
                                                            onBlur={() => handleBlur("limited_edition")}
                                                        />
                                                        <label className="form-check-label mt-1" htmlFor="flexRadioNo">
                                                            No
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                            {errors.limited_edition && <p className="text-danger mt-1">{errors.limited_edition}</p>}
                                        </div>

                                        <div className="col-md-12 mb-3">
                                            <FormGroup className="form-group">
                                                <Label className="mb-1 lableSmall">Edition Size</Label>
                                                <Input
                                                    id="form-control"
                                                    name="edition_size"
                                                    value={fields.edition_size}
                                                    onChange={handleInputChange}
                                                    onBlur={() => handleBlur("edition_size")}
                                                    placeholder="Enter edition size"
                                                    className={`form-control bg-white ${errors.edition_size ? "border-danger" : ""}`}
                                                    innerRef={editionSizeRef} // ✅ Attach ref like in "Edition" field
                                                />
                                                {errors.edition_size && <p className="text-danger mt-1">{errors.edition_size}</p>}
                                            </FormGroup>

                                        </div>

                                        {isPhysicalArt === true &&
                                            <div class="col-md-12 mb-3">
                                                <label>Edition Size (i.e., authorized maximum number of Edition Prints and Edition Proofs combined)</label>
                                                <FormGroup className="form-group">
                                                    {/* <Label className="mb-1 lableSmall">Combined Edition Size</Label> */}
                                                    <Input
                                                        id="form-control"
                                                        name="combined_edition_size"
                                                        value={fields.combined_edition_size}
                                                        onChange={handleInputChange}
                                                        onBlur={() => handleBlur("combined_edition_size")}
                                                        placeholder="Enter Edition Size"
                                                        className={`form-control bg-white ${errors.combined_edition_size ? "border-danger" : ""}`}
                                                        innerRef={combinedEditionSizeRef} // ✅ Attach ref for error scrolling
                                                    />
                                                    {errors.combined_edition_size && <p className="text-danger mt-1">{errors.combined_edition_size}</p>}
                                                </FormGroup>

                                            </div>}
                                        {isPhysicalArt === true &&
                                            <div className="col-md-12">
                                                <div className='row'>
                                                    <div class="col-md-12 mb-3">

                                                        <FormGroup className="form-group mb-4">
                                                            <Label className="mb-1 lableSmall">Edition Prints</Label>
                                                            <Input
                                                                id="form-control"
                                                                name="edition_print"
                                                                value={fields.edition_print}
                                                                onChange={handleInputChange}
                                                                onBlur={() => handleBlur("edition_print")}
                                                                placeholder="Enter Edition Print"
                                                                className={`form-control bg-white ${errors.edition_print ? "border-danger" : ""}`}
                                                                innerRef={editionPrintInputRef} // ✅ Attach ref for focus and scroll
                                                            />
                                                            {errors.edition_print && <p className="text-danger mt-1">{errors.edition_print}</p>}
                                                        </FormGroup>

                                                    </div>
                                                    <div class="col-md-12 mb-3">

                                                        <FormGroup className="form-group mb-0">
                                                            <Label className="mb-1 lableSmall">Authorized maximum number</Label>

                                                            <Input
                                                                id="form-control"
                                                                name="authorized_max_number"
                                                                value={fields?.authorized_max_number}
                                                                onChange={(e) => handleInputChange(e)}
                                                                onBlur={(e) => handleBlur(e.target.name)}
                                                                placeholder="Enter authorized maximum number"
                                                                className={`form-control bg-white ${errors.authorized_max_number ? "is-invalid" : ""}`}
                                                                innerRef={authorizedMaxNumberRef} // ✅ Use `innerRef` for Reactstrap Input
                                                            />

                                                            {errors.authorized_max_number && <div className="text-danger">{errors.authorized_max_number}</div>}
                                                        </FormGroup>
                                                    </div>
                                                </div>


                                            </div>}
                                        {isPhysicalArt === true &&
                                            <div className="col-md-12 mb-3">

                                                <FormGroup className="form-group mb-0">
                                                    <Label className="mb-1 lableSmall">Authorized maximum number numbered but not signed</Label>
                                                    <Input
                                                        id="form-control"
                                                        name="authorized_max_number_not_signed"
                                                        value={fields?.authorized_max_number_not_signed}
                                                        onChange={(e) => handleInputChange(e)}
                                                        onBlur={() => handleBlur("authorized_max_number_not_signed")}
                                                        placeholder="Enter authorized maximum number numbered but not signed"
                                                        className={`form-control bg-white ${errors.authorized_max_number_not_signed ? "border-danger" : ""}`}
                                                        innerRef={authorizedMaxNotSignedRef} // ✅ Attach ref for focus and scroll
                                                    />

                                                    {errors.authorized_max_number_not_signed && (
                                                        <p className="text-danger mt-1">{errors.authorized_max_number_not_signed}</p>
                                                    )}
                                                </FormGroup>

                                            </div>
                                        }
                                        {isPhysicalArt === true &&
                                            <div class="col-md-12 mb-3">
                                                <FormGroup className="form-group mb-0">
                                                    <Label className="mb-1 lableSmall">Authorized maximum number signed and numbered</Label>

                                                    <Input
                                                        id="form-control"
                                                        name="authorized_max_number_signed"
                                                        value={fields?.authorized_max_number_signed}
                                                        onChange={(e) => handleInputChange(e)}
                                                        onBlur={() => handleBlur("authorized_max_number_signed")}
                                                        placeholder="Enter authorized maximum number signed and numbered"
                                                        className={`form-control bg-white ${errors.authorized_max_number_signed ? "border-danger" : ""}`}
                                                        innerRef={authorizedMaxSignedRef} // ✅ Attach ref for focus and scroll
                                                    />

                                                    {errors.authorized_max_number_signed && (
                                                        <p className="text-danger mt-1">{errors.authorized_max_number_signed}</p>
                                                    )}
                                                </FormGroup>


                                            </div>
                                        }
                                        {isPhysicalArt === true &&
                                            <div class="col-md-12 mb-3">
                                                <label>Authorized maximum number neither signed nor numbered</label>
                                                <FormGroup className="form-group mb-0">
                                                    <Input
                                                        id="form-control"
                                                        name="authorized_max_number_nothing"
                                                        value={fields?.authorized_max_number_nothing}
                                                        onChange={(e) => handleInputChange(e)}
                                                        onBlur={() => handleBlur("authorized_max_number_nothing")}
                                                        placeholder="Enter authorized maximum number neither signed nor numbered"
                                                        className={`form-control bg-white ${errors.authorized_max_number_nothing ? "border-danger" : ""}`}
                                                        innerRef={authorizedMaxNothingRef} // ✅ Attach ref for focus and scroll
                                                    />

                                                    {errors.authorized_max_number_nothing && (
                                                        <p className="text-danger mt-1">{errors.authorized_max_number_nothing}</p>
                                                    )}
                                                </FormGroup>
                                                {/* {done till here} */}
                                            </div>
                                        }
                                        {isPhysicalArt === true &&
                                            <div class="col-md-12 mb-3">
                                                <p className="edit-info mb-1">Edition Proofs </p>

                                                <div className="form-group ps-4">
                                                    <label className="">Authorized maximum number</label>

                                                    <Input
                                                        id="form-control"
                                                        name="edition_authorized_max_number"
                                                        type="text"
                                                        value={fields?.edition_authorized_max_number}
                                                        onChange={(e) => handleInputChange(e)}
                                                        onBlur={() => handleBlur("edition_authorized_max_number")}
                                                        placeholder="Enter authorized maximum number."
                                                        className={`form-control bg-white ${errors.edition_authorized_max_number ? "border-danger" : ""}`}
                                                        innerRef={editionAuthorizedMaxRef} // ✅ Attach ref for focus and scroll
                                                    />

                                                    {errors.edition_authorized_max_number && (
                                                        <p className="text-danger mt-1">{errors.edition_authorized_max_number}</p>
                                                    )}
                                                </div>

                                                <div className="form-group ps-4">
                                                    <label>Artist’s proofs:</label>

                                                    <Input
                                                        id="form-control"
                                                        name="edition_artist_proof"
                                                        type="text"
                                                        value={fields?.edition_artist_proof}
                                                        onChange={(e) => handleInputChange(e)}
                                                        onBlur={() => handleBlur("edition_artist_proof")}
                                                        placeholder="Enter artist’s proofs"
                                                        className={`form-control bg-white ${errors.edition_artist_proof ? "border-danger" : ""}`}
                                                        innerRef={editionArtistProofRef} // ✅ Attach ref for focus and scroll
                                                    />

                                                    {errors.edition_artist_proof && (
                                                        <p className="text-danger mt-1">{errors.edition_artist_proof}</p>
                                                    )}
                                                </div>

                                                <div className="form-group ps-4">
                                                    <label>Printer’s proofs</label>

                                                    <Input
                                                        id="form-control"
                                                        name="edition_printer_proof"
                                                        type="text"
                                                        value={fields?.edition_printer_proof}
                                                        onChange={(e) => handleInputChange(e)}
                                                        onBlur={() => handleBlur("edition_printer_proof")}
                                                        placeholder="Enter printer’s proofs"
                                                        className={`form-control bg-white ${errors.edition_printer_proof ? "border-danger" : ""}`}
                                                        innerRef={editionPrinterProofRef} // ✅ Attach ref for focus and scroll
                                                    />

                                                    {errors.edition_printer_proof && (
                                                        <p className="text-danger mt-1">{errors.edition_printer_proof}</p>
                                                    )}
                                                </div>

                                                <div className="form-group ps-4">
                                                    <label>Other proofs</label>

                                                    <Input
                                                        id="form-control"
                                                        name="edition_other_prrof"
                                                        type="text"
                                                        value={fields?.edition_other_prrof}
                                                        onChange={(e) => handleInputChange(e)}
                                                        onBlur={() => handleBlur("edition_other_prrof")}
                                                        placeholder="Enter other proofs"
                                                        className={`form-control bg-white ${errors.edition_other_prrof ? "border-danger" : ""}`}
                                                        innerRef={editionOtherProofRef} // ✅ Attach ref for focus and scroll
                                                    />

                                                    {errors.edition_other_prrof && (
                                                        <p className="text-danger mt-1">{errors.edition_other_prrof}</p>
                                                    )}
                                                </div>


                                            </div>}
                                        {isPhysicalArt === false &&
                                            <div class="col-md-12 mb-3">
                                                <label>Edition Proofs</label>
                                                <p className="edit-info mb-0">None</p>

                                            </div>
                                        }
                                        <div class="col-md-12 mb-3">
                                            <label>Artist living when Edition released </label>
                                            <div className="d-flex gap-4 align-items-center">
                                                <div>
                                                    <div className="form-check d-flex align-items-center">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="edition_artist_living"
                                                            id="flexRadioYes"
                                                            value="Yes"
                                                            checked={fields?.edition_artist_living === "Yes"}
                                                            onChange={handleInputChange}
                                                            ref={editionArtistLivingRef} // Step 2: Attach ref to first radio button
                                                        />
                                                        <label className="form-check-label mt-1" htmlFor="flexRadioYes">
                                                            Yes
                                                        </label>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className="form-check d-flex align-items-center">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="edition_artist_living"
                                                            id="flexRadioNo"
                                                            value="No"
                                                            checked={fields?.edition_artist_living === "No"}
                                                            onChange={handleInputChange}
                                                        />
                                                        <label className="form-check-label mt-1" htmlFor="flexRadioNo">
                                                            No
                                                        </label>
                                                    </div>
                                                </div>

                                            </div>
                                            {errors.edition_artist_living && (
                                                <p className="text-danger mt-1">{errors.edition_artist_living}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-5'>
                                    <div className='row'>
                                        <div class="col-md-12 mb-3">
                                            <p className="edit-info mt-3 mb-0">Master Information</p>
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <FormGroup className="form-group mb-0">
                                                <Label className="mb-1 lableSmall">Year Master Created</Label>

                                                <Input
                                                    id="form-control"
                                                    name="year_master_created"
                                                    value={fields.year_master_created}
                                                    onChange={handleInputChange}
                                                    onBlur={() => handleBlur("year_master_created")}
                                                    placeholder="Enter year master created."
                                                    className={`form-control bg-white ${errors.year_master_created ? "border-danger" : ""}`}
                                                    innerRef={yearMasterCreatedRef} // ✅ Attach ref for focus and scroll
                                                />

                                                {errors.year_master_created && (
                                                    <p className="text-danger mt-1">{errors.year_master_created}</p>
                                                )}
                                            </FormGroup>
                                        </div>

                                        <div class="col-md-12 mb-3">
                                            <label>Artist living when Print made</label>




                                            <div className="d-flex gap-4 align-items-center">
                                                <div>
                                                    <div className="form-check d-flex align-items-center">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="master_artist_living"
                                                            id="radioYes"
                                                            value="Yes"
                                                            checked={fields?.master_artist_living === "Yes"}
                                                            onChange={handleInputChange}
                                                            onBlur={() => handleBlur("master_artist_living")}
                                                            ref={masterArtistLivingRef} // Attach ref to first radio
                                                        />
                                                        <label className="form-check-label mt-1" htmlFor="radioYes">
                                                            Yes
                                                        </label>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className="form-check d-flex align-items-center">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="master_artist_living"
                                                            id="radioNo"
                                                            value="No"
                                                            checked={fields?.master_artist_living === "No"}
                                                            onChange={handleInputChange}
                                                            onBlur={() => handleBlur("master_artist_living")}
                                                        />
                                                        <label className="form-check-label mt-1" htmlFor="radioNo">
                                                            No
                                                        </label>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                        {errors.master_artist_living && (
                                            <p className="text-danger mt-1">{errors.master_artist_living}</p>
                                        )}
                                        <div class="col-md-12 mb-3">
                                            <label>Other masters of the Artwork exist?</label>
                                            <div className="d-flex gap-4 align-items-center">
                                                <div>
                                                    <div className="form-check d-flex align-items-center">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="master_artwork_exist"
                                                            id="radioYes"
                                                            value="Yes"
                                                            checked={fields?.master_artwork_exist === "Yes"}
                                                            onChange={handleInputChange}
                                                            onBlur={() => handleBlur("master_artwork_exist")}
                                                            ref={masterArtworkExistRef} // Attach ref to first radio
                                                        />
                                                        <label className="form-check-label mt-1" htmlFor="radioYes">
                                                            Yes
                                                        </label>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className="form-check d-flex align-items-center">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="master_artwork_exist"
                                                            id="radioNo"
                                                            value="No"
                                                            checked={fields?.master_artwork_exist === "No"}
                                                            onChange={handleInputChange}
                                                            onBlur={() => handleBlur("master_artwork_exist")}
                                                        />
                                                        <label className="form-check-label mt-1" htmlFor="radioNo">
                                                            No
                                                        </label>
                                                    </div>
                                                </div>

                                            </div>
                                            {errors.master_artwork_exist && (
                                                <p className="text-danger mt-1">{errors.master_artwork_exist}</p>
                                            )}
                                        </div>
                                        <div class="col-md-12 mb-3">
                                            <label>Description</label>
                                            <textarea type="text" id="form-control" class="form-control textarea-text" maxLength="500" className="form-control textarea-text" name="description"
                                                placeholder="Enter a description (optional)" value={fields?.description}
                                                onChange={(e) => handleInputChange(e)}> </textarea>
                                        </div>
                                        {isPhysicalArt === false &&
                                            <div class="col-md-12 mb-3">

                                                <FormGroup className="form-group mb-0">
                                                    <Label className="mb-1 lableSmall">Limited editions produced from the Master</Label>

                                                    <Input
                                                        id="form-control"
                                                        name="other_limited_edition"
                                                        value={fields.other_limited_edition || ""}
                                                        onChange={handleInputChange}
                                                        onBlur={() => handleBlur("other_limited_edition")}
                                                        placeholder="Enter limited editions produced from the Master"
                                                        className={`form-control bg-white ${errors.other_limited_edition ? "border-danger" : ""}`}
                                                        innerRef={otherLimitedEditionRef} // ✅ Attach ref for focus and scroll
                                                    />

                                                    {errors.other_limited_edition && (
                                                        <p className="text-danger mt-1">{errors.other_limited_edition}</p>
                                                    )}
                                                </FormGroup>

                                            </div>}
                                        {isPhysicalArt === true &&
                                            <div class="col-md-12 mb-3">

                                                <FormGroup className="form-group mb-0">
                                                    <Label className="mb-1 lableSmall">Other limited editions produced from the Master</Label>
                                                    <Input id="form-control"
                                                        name="other_limited_edition"

                                                        value={fields.other_limited_edition || ""} // Bind input to state
                                                        onChange={handleInputChange}
                                                        onBlur={(e) => handleBlur("other_limited_edition")} // Blur validation                                        
                                                        placeholder="Enter other limited editions produced from the Master"
                                                        className="form-control bg-white"
                                                        required={fieldsError?.nameError}
                                                        innerRef={otherMasterLimitedEditionRef}
                                                    // placeholder="Item Name"
                                                    />
                                                </FormGroup>
                                                {errors.other_limited_edition && <p className="text-danger mt-1">{errors.other_limited_edition}</p>}
                                            </div>
                                        }
                                        <div className='col-md-12 mb-3'>
                                            <div className='row'>
                                                <div className="col-md-6 mb-3">
                                                    <FormGroup className="form-group mb-0">
                                                        <Label className="mb-1 lableSmall">Edition</Label>
                                                        <Input
                                                            id="form-control"
                                                            name="master_edition"
                                                            value={fields.master_edition || ""} // Bind input to state
                                                            onChange={handleInputChange}
                                                            onBlur={() => handleBlur("master_edition")} // ✅ Corrected blur function call
                                                            placeholder="Enter Master Edition"
                                                            className={`form-control bg-white ${errors.master_edition ? "border-danger" : ""}`} // ✅ Adds red border if there's an error
                                                            required // ✅ Ensures the field is required
                                                            innerRef={masterEditionRef}
                                                        />
                                                        {errors.master_edition && <p className="text-danger mt-1">{errors.master_edition}</p>}  {/* ✅ Shows error message */}
                                                    </FormGroup>
                                                </div>

                                                <div className="col-md-6 mb-3"> {/* ✅ Fixed className issue */}
                                                    <FormGroup className="form-group mb-0">
                                                        <Label className="mb-1 lableSmall">Edition Points</Label>
                                                        <Input
                                                            id="form-control"
                                                            type="number"
                                                            name="edition_points"
                                                            value={fields.edition_points || ""} // ✅ Ensures controlled input
                                                            onChange={handleInputChange}
                                                            onBlur={() => handleBlur("edition_points")} // ✅ Better onBlur function
                                                            placeholder="Enter edition points"
                                                            className={`form-control bg-white ${errors.edition_points ? "border-danger" : ""}`} // ✅ Highlights error
                                                            required // ✅ Ensures required field
                                                            innerRef={editionPointsRef}
                                                        />
                                                        {errors.edition_points && <p className="text-danger mt-1">{errors.edition_points}</p>}  {/* ✅ Error message display */}
                                                    </FormGroup>
                                                </div>

                                                <div class="col-md-6 mb-3">

                                                    <FormGroup className="form-group mb-0">
                                                        <Label className="mb-1 lableSmall">Proofs</Label>
                                                        <Input
                                                            id="form-control"
                                                            name="other_master_proofs"
                                                            value={fields.other_master_proofs || ""} // ✅ Ensures controlled input
                                                            onChange={handleInputChange}
                                                            onBlur={() => handleBlur("other_master_proofs")} // ✅ Better onBlur function
                                                            placeholder="Enter proofs"
                                                            className={`form-control bg-white ${errors.other_master_proofs ? "border-danger" : ""}`} // ✅ Highlights error
                                                            required // ✅ Ensures required field
                                                            innerRef={otherMasterProofsRef}
                                                        />
                                                        {errors.other_master_proofs && <p className="text-danger mt-1">{errors.other_master_proofs}</p>}  {/* ✅ Error message display */}
                                                    </FormGroup>

                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <FormGroup className="form-group mb-0">
                                                        <Label className="mb-1 lableSmall">Signed/Numbered</Label>
                                                        <Input
                                                            id="form-control"
                                                            name="signed_number"
                                                            value={fields.signed_number || ""} // ✅ Ensures controlled input
                                                            onChange={handleInputChange}
                                                            onBlur={() => handleBlur("signed_number")} // ✅ Better onBlur function
                                                            placeholder="Enter Signed/Numbered"
                                                            className={`form-control bg-white ${errors.signed_number ? "border-danger" : ""}`} // ✅ Adds red border if error exists
                                                            required // ✅ Ensures required field
                                                            innerRef={signedNumberRef}
                                                        />
                                                        {errors.signed_number && <p className="text-danger mt-1">{errors.signed_number}</p>} {/* ✅ Error message display */}
                                                    </FormGroup>
                                                </div>

                                            </div>
                                        </div>
                                        {isPhysicalArt === true && <>
                                            <div className="col-md-12 mb-3">
                                                <FormGroup className="form-group mb-0">
                                                    <Label className="mb-1 lableSmall">
                                                        Editions from the Master other than limited editions
                                                    </Label>
                                                    <Input
                                                        id="form-control"
                                                        name="other_master_edition"
                                                        value={fields.other_master_edition || ""} // ✅ Ensures controlled input
                                                        onChange={handleInputChange}
                                                        onBlur={() => handleBlur("other_master_edition")} // ✅ Directly calls handleBlur with correct field name
                                                        placeholder="Enter editions from the Master other than limited editions"
                                                        className={`form-control bg-white ${errors.other_master_edition ? "border-danger" : ""}`} // ✅ Adds red border if error exists
                                                        required // ✅ Ensures required field
                                                        innerRef={otherMasterEditionRef}
                                                    />
                                                    {errors.other_master_edition && (
                                                        <p className="text-danger mt-1">{errors.other_master_edition}</p> // ✅ Displays error message
                                                    )}
                                                </FormGroup>
                                            </div>

                                            <div className='col-md-12 mb-3'>
                                                <div className='row'>
                                                    <div className="col-md-6 mb-3">
                                                        <FormGroup className="form-group mb-0">
                                                            <Label className="mb-1 lableSmall">Edition</Label>
                                                            <Input
                                                                id="form-control"
                                                                name="master_edition2"
                                                                value={fields.master_edition2 || ""} // ✅ Ensures controlled input
                                                                onChange={handleInputChange}
                                                                onBlur={() => handleBlur("master_edition2")} // ✅ Calls handleBlur with correct field name
                                                                placeholder="Enter Edition"
                                                                className={`form-control bg-white ${errors.master_edition2 ? "border-danger" : ""}`} // ✅ Highlights input if there's an error
                                                                required // ✅ Ensures required field validation
                                                                innerRef={masterEdition2Ref}
                                                            />
                                                            {errors.master_edition2 && (
                                                                <p className="text-danger mt-1">{errors.master_edition2}</p> // ✅ Displays error message
                                                            )}
                                                        </FormGroup>
                                                    </div>

                                                    <div class="col-md-6 mb-3">

                                                        <FormGroup className="form-group mb-0">
                                                            <Label className="mb-1 lableSmall">Edition Points</Label>
                                                            <Input id="form-control"
                                                                name="other_master_edition_points"
                                                                value={fields.other_master_edition_points || ""} // Bind input to state
                                                                onChange={handleInputChange}
                                                                onBlur={(e) => handleBlur(e.target.name)} // B    

                                                                // onChange={onChangeHandler("name")}
                                                                placeholder="Enter edition points"
                                                                className="form-control bg-white"
                                                                required={fieldsError?.nameError}
                                                                innerRef={otherMasterEditionPointsRef}
                                                            // placeholder="Item Name"
                                                            />
                                                            {errors.other_master_edition_points && (
                                                                <p className="text-danger mt-1">{errors.other_master_edition_points}</p> // ✅ Displays error message
                                                            )}
                                                        </FormGroup>
                                                    </div>
                                                    <div class="col-md-6 mb-3">

                                                        <FormGroup className="form-group mb-0">
                                                            <Label className="mb-1 lableSmall">Proofs</Label>
                                                            <Input id="form-control"
                                                                name="master_proofs"
                                                                value={fields.master_proofs || ""} // 
                                                                onChange={handleInputChange}
                                                                onBlur={(e) => handleBlur(e.target.name)} // B 
                                                                innerRef={masterProofsRef}
                                                                placeholder="Enter proofs"
                                                                className="form-control bg-white"
                                                                required={fieldsError?.nameError}
                                                            />
                                                            {errors.master_proofs && (
                                                                <p className="text-danger mt-1">{errors.master_proofs}</p> // ✅ Displays error message
                                                            )}
                                                        </FormGroup>
                                                    </div>
                                                    <div class="col-md-6 mb-3">
                                                        <FormGroup className="form-group mb-0">
                                                            <Label className="mb-1 lableSmall">Signed/numbered</Label>
                                                            <Input id="form-control"
                                                                name="master_signed_number"
                                                                value={fields.master_signed_number || ""} // 
                                                                onChange={handleInputChange}
                                                                onBlur={(e) => handleBlur(e.target.name)} // B 
                                                                innerRef={masterSignedNumberRef}
                                                                // onChange={onChangeHandler("name")}

                                                                className="form-control bg-white"
                                                                required={fieldsError?.nameError}
                                                                placeholder="Enter a Signed/numbered"
                                                            />
                                                            {errors.master_signed_number && (
                                                                <p className="text-danger mt-1">{errors.master_signed_number}</p> // ✅ Displays error message if validation fails
                                                            )}
                                                        </FormGroup>
                                                    </div>
                                                </div>
                                            </div>
                                        </>}
                                        <div className="col-md-12 mb-3">
                                            <FormGroup className="form-group mb-0">
                                                <Label className="mb-1 lableSmall">How Numbered</Label>
                                                <Input
                                                    id="form-control"
                                                    name="how_numbered"
                                                    value={fields.how_numbered || ""} // ✅ Ensures controlled input
                                                    onChange={handleInputChange}
                                                    onBlur={() => handleBlur("how_numbered")} // ✅ Calls handleBlur with the correct field name
                                                    placeholder="Enter how numbered"
                                                    className={`form-control bg-white ${errors.how_numbered ? "border-danger" : ""}`} // ✅ Adds red border for errors
                                                    required // ✅ Ensures the field is required
                                                    innerRef={howNumberedRef}
                                                />
                                                {errors.how_numbered && (
                                                    <p className="text-danger mt-1">{errors.how_numbered}</p> // ✅ Displays error message if validation fails
                                                )}
                                            </FormGroup>
                                        </div>

                                        <div className="col-md-12 mb-3">
                                            <FormGroup className="form-group mb-0">
                                                <Label className="mb-1 lableSmall">
                                                    Total number of prints in other editions, limited or other, produced from the Master
                                                </Label>
                                                <Input
                                                    id="form-control"
                                                    name="other_prints"
                                                    type="number" // ✅ Use type="number" if the input should only accept numbers
                                                    value={fields.other_prints || ""}
                                                    onChange={handleInputChange}
                                                    onBlur={() => handleBlur("other_prints")} // ✅ Properly calls handleBlur with the correct field name
                                                    placeholder="Enter total number of prints in other editions, limited or other, produced from the Master"
                                                    className={`form-control bg-white ${errors.other_prints ? "border-danger" : ""}`} // ✅ Adds a red border for errors
                                                    required
                                                    innerRef={otherPrintsRef}
                                                />
                                                {errors.other_prints && (
                                                    <p className="text-danger mt-1">{errors.other_prints}</p> // ✅ Displays an error message if validation fails
                                                )}
                                            </FormGroup>
                                        </div>

                                        <div className="col-md-12 mb-3">
                                            <FormGroup className="form-group mb-0">
                                                <Label className="mb-1 lableSmall">
                                                    Total number of prints produced from the Master that are not part of any edition
                                                </Label>
                                                <Input
                                                    id="form-control"
                                                    name="print_produced"
                                                    type="number" // ✅ Ensures only numerical values
                                                    value={fields.print_produced || ""}
                                                    onChange={handleInputChange}
                                                    onBlur={() => handleBlur("print_produced")} // ✅ Cleaner and better function call
                                                    placeholder="Enter total number of prints produced from the Master that are not part of any edition"
                                                    className={`form-control bg-white ${errors.print_produced ? "border-danger" : ""}`} // ✅ Highlights errors
                                                    required
                                                    innerRef={printProducedRef}
                                                />
                                                {errors.print_produced && (
                                                    <p className="text-danger mt-1">{errors.print_produced}</p> // ✅ Displays error message
                                                )}
                                            </FormGroup>
                                        </div>

                                        <div class="col-md-12 mb-3">

                                            <FormGroup className="form-group mb-0">
                                                <Label className="mb-1 lableSmall">Number of authorized prints of the Artwork not produced from the Master</Label>
                                                <Input id="form-control"
                                                    name="non_master_authorized_prints"
                                                    value={fields.non_master_authorized_prints || ""} // 
                                                    onChange={handleInputChange}
                                                    onBlur={(e) => handleBlur(e.target.name)} // B 

                                                    // onChange={onChangeHandler("name")}
                                                    placeholder="Enter number of authorized prints of the Artwork not produced from the Master"
                                                    className="form-control bg-white"
                                                    required={fieldsError?.nameError}
                                                    innerRef={nonMasterAuthorizedPrintsRef}
                                                // placeholder="Item Name"
                                                />
                                                {errors.non_master_authorized_prints && (
                                                    <p className="text-danger mt-1">{errors.non_master_authorized_prints}</p> // ✅ Displays error message if validation fails
                                                )}
                                            </FormGroup>


                                        </div>
                                        <div class="col-md-12 mb-3">
                                            <label>Master destroyed, effaced, altered, defaced or canceled</label>
                                            <div className="d-flex gap-4 align-items-center">


                                                <div className="d-flex gap-4 align-items-center">
                                                    <div>
                                                        <div className="form-check d-flex align-items-center">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="destroyed"
                                                                id="flexRadioYes"
                                                                value="Yes"
                                                                checked={fields?.destroyed === "Yes"}
                                                                onChange={handleInputChange}
                                                                onBlur={() => handleBlur("destroyed")}
                                                                ref={destroyedRef} // Attach ref to first radio
                                                            />
                                                            <label className="form-check-label mt-1" htmlFor="flexRadioYes">
                                                                Yes
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div className="form-check d-flex align-items-center">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="destroyed"
                                                                id="flexRadioNo"
                                                                value="No"
                                                                checked={fields?.destroyed === "No"}
                                                                onChange={handleInputChange}
                                                                onBlur={() => handleBlur("destroyed")}
                                                                ref={destroyedRef}
                                                            />
                                                            <label className="form-check-label mt-1" htmlFor="flexRadioNo">
                                                                No
                                                            </label>
                                                        </div>
                                                    </div>

                                                </div>
                                            
                                            </div>
                                            {errors.destroyed && (
                                                    <p className="text-danger mt-1">{errors.destroyed}</p>
                                                )}
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <FormGroup className="form-group mb-0">
                                                <Label className="mb-1 lableSmall">Master Created By</Label>
                                                <Input
                                                    id="form-control"
                                                    name="main_artist"
                                                    type="text" // ✅ Ensures only text input
                                                    value={fields?.main_artist || ""}
                                                    onChange={handleInputChange}
                                                    onBlur={() => handleBlur("main_artist")}
                                                    placeholder="Enter master creator's name"
                                                    className={`form-control bg-white ${errors?.main_artist ? "border-danger" : ""}`} // ✅ Highlights errors
                                                    required
                                                    innerRef={mainArtistRef}
                                                />
                                                {errors?.main_artist && (
                                                    <p className="text-danger mt-1">{errors.main_artist}</p> // ✅ Displays error message
                                                )}
                                            </FormGroup>
                                        </div>

                                        <div className="col-md-12 mb-3">
                                            <FormGroup className="form-group mb-0">
                                                <Label className="mb-1 lableSmall">Other Artists</Label>
                                                <Input
                                                    id="form-control"
                                                    name="other_artists"
                                                    type="text" // ✅ Ensures text input only
                                                    value={fields?.other_artists || ""}
                                                    onChange={handleInputChange}
                                                    onBlur={() => handleBlur("other_artists")}
                                                    placeholder="Enter other artists"
                                                    className={`form-control bg-white ${errors?.other_artists ? "border-danger" : ""}`} // ✅ Highlights errors
                                                    required
                                                    innerRef={otherArtistsRef}
                                                />
                                                {errors?.other_artists && (
                                                    <p className="text-danger mt-1">{errors.other_artists}</p> // ✅ Displays error message
                                                )}
                                            </FormGroup>
                                        </div>

                                    </div>
                                </div>

                            </div>


                            <br />
                            <div id="modal-footer" style={{ color: "white !important", textAlign: "center !important", position: "absolute", bottom: '0', width: '100% !important' }}>
                                Artwork Copyright: © year   name of copyright holder
                            </div>
                        </form>


                        <div>
                            <p className="all-this mb-3">THIS IS TO CERTIFY that all information and statements contained herein are true and correct.</p>
                        </div>
                        <br />
                        <div className="d-flex justify-content-between">
                            <div className="flex-div">
                                <Input id="form-control"
                                    name="name"

                                    // onChange={onChangeHandler("name")}
                                    placeholder=""
                                    className="form-control bg-white text-center"
                                    required={fieldsError?.nameError}
                                // placeholder="Item Name"
                                />
                                <p className="signature-text">Signature</p>
                            </div>

                            <div className="flex-div">
                                <Input id="form-control"
                                    name="name"

                                    // onChange={onChangeHandler("name")}
                                    placeholder=""
                                    className="form-control bg-white text-center"
                                    required={fieldsError?.nameError}
                                // placeholder="Item Name"
                                />
                                <p className="signature-text">Date</p>
                            </div>

                            <div className="flex-div">
                                <Input id="form-control"
                                    name="name"

                                    // onChange={onChangeHandler("name")}
                                    placeholder=""
                                    className="form-control bg-white text-center"
                                    required={fieldsError?.nameError}
                                // placeholder="Item Name"
                                />
                                <p className="signature-text">Printer Name</p>
                            </div>
                        </div>


                    </div>

                    <div className="modal-footer">
                        {/* <button type="button" className="btn btn-secondary" >
                Close
              </button> */}
                        <button type="button" className="btn btn-primary" onClick={handleSubmit}>
                            Save changes
                        </button>
                    </div>
                </div>
            </div>

        </div>

    </>;
});

export default CertificateofAuthenticity;
